import { addStyles } from 'ethcss'
import { color, IStyles } from 'theme'

const templateEditorElementViewsStyles: IStyles = {
    shape: {
        width: '100%',
        height: '100%',
    },
    text: {
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'flex-start',
        padding: 4,
        boxSizing: 'border-box',
        overflow: 'hidden',
        wordBreak: 'break-word',
        lineHeight: 1.23,
        fontFamily: 'inherit',
    },
    media: {
        width: '100%',
        height: '100%',
        position: 'relative',
        overflow: 'hidden',
        background: color.bgWhiteSecondary,
    },
    mediaImage: {
        width: '100%',
        height: '100%',
        objectFit: 'contain',
        display: 'block',
    },
    mediaVideo: {
        width: '100%',
        height: '100%',
        objectFit: 'contain',
        display: 'block',
        background: color.bgDarkPrimary,
        pointerEvents: 'none',
    },
    mediaBadge: {
        position: 'absolute',
        right: 8,
        bottom: 8,
        width: 24,
        height: 24,
        borderRadius: '50%',
        background: 'rgba(0,0,0,0.55)',
        color: color.bgWhitePrimary,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: 10,
        pointerEvents: 'none',
    },
    mediaPlaceholder: {
        width: '100%',
        height: '100%',
        background: `linear-gradient(135deg, ${color.blue100}, ${color.info100})`,
    },
    listVertical: {
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        padding: 8,
        boxSizing: 'border-box',
        overflow: 'hidden',
    },
    listHorizontal: {
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        padding: 8,
        boxSizing: 'border-box',
        overflow: 'hidden',
    },
    listItem: {
        display: 'flex',
        alignItems: 'flex-start',
        gap: 8,
        minWidth: 0,
    },
    listBullet: {
        flexShrink: 0,
        color: color.blue,
    },
    table: {
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        border: `1px solid ${color.borderDarkPrimary}`,
        boxSizing: 'border-box',
        overflow: 'hidden',
    },
    tableRow: {
        display: 'flex',
        width: '100%',
        minHeight: 0,
    },
    tableCell: {
        borderRight: `1px solid ${color.borderDarkPrimary}`,
        borderBottom: `1px solid ${color.borderDarkPrimary}`,
        boxSizing: 'border-box',
        overflow: 'hidden',
        display: 'flex',
        alignItems: 'center',
        minWidth: 0,
    },
    editableText: {
        flex: 1,
        minWidth: 0,
        width: '100%',
        outline: 'none',
        wordBreak: 'break-word',
        whiteSpace: 'pre-wrap',

        '&[contenteditable="true"]': {
            cursor: 'text',
            boxShadow: `inset 0 0 0 2px ${color.info}`,
        },
    },
}

addStyles(templateEditorElementViewsStyles)
export default templateEditorElementViewsStyles
